import { BaseService } from './base-service';
import { CallResponse, CitiesResponse } from '../types';

export class LocationService extends BaseService {
  public async getCitiesByCountry(keyword: string, countryCode: string): Promise<string[]> {
    try {
      const response = await this.callHeyApiTech(
        'GET',
        `/v3/cities?keyword=${keyword}&countryCode=${countryCode}`,
        null
      );
       if (!response.success || !response.data) {
        console.error('Failed to fetch cities:', response.error);
        return [];
      }

      const citiesData = response.data as CitiesResponse;
      return citiesData.data.map(city => city.name);
    } catch (error) {
      console.error('Failed to fetch cities:', error);
      return [];
    }
  }
}